<template>
  <div id="wrapper" class="page">
    <div id="content-wrapper">
      <div class="container-fluid">
         <b-row>
            <b-col cols="12">
              <div class="form-inline">
                <button class="btn btn-info mb-2 mr-2" @click.prevent="openCostModal">
                  <i class="fas fa-plus"></i> Add
                </button>
                <b-form-select v-model="year_selected" class="mb-2 mr-2" style="width: 7%" :options="optionsYear" value-field="value" text-field="text" @change="queryItem">
                  <template #first>
                    <b-form-select-option value="-1">Year</b-form-select-option>
                  </template>
                </b-form-select>
                <b-form-select v-model="month_selected" class="mb-2 mr-2" style="width: 7%" :options="optionsMonth" value-field="value" text-field="text" @change="queryItem">
                  <template #first>
                    <b-form-select-option value="-1">Month</b-form-select-option>
                  </template>
                </b-form-select>
                <div style="flex-grow: 1" />
                <button class="btn btn-success mb-2 mr-2" style="float:right;" @click.prevent="exportExcel" >
                <i class="far fa-file-excel"></i> Report
              </button>
              </div>
            </b-col>
          </b-row>
          <b-table
          bordered
          head-variant="dark"
          hover
          responsive
          striped
          small
          table-variant="light"
          :fields="qtake_cost_fields"
          :items="qtake_cost_items"
          >
            <template v-slot:cell(name)="data">
              <b v-if="data.item.invoice=='#*HEADER@&!'">{{data.item.name}}</b>
              <div v-else-if="data.item.qtake_employee != 0">
                {{employees.find(x => x.id == data.item.qtake_employee).hovaten}}
              </div>
              <div v-else>{{data.item.name}}</div>
            </template>
            <template v-slot:cell(per_month_usd)="data">
              <b v-if="data.item.invoice=='#*HEADER@&!'">{{data.item.per_month_usd  | numeral('0,0')}}</b>
              <div v-else>{{data.item.per_month_usd | numeral('0,0')}}</div>
            </template>
            <template v-slot:cell(invoice)="data">
              <div v-if="data.item.invoice!='#*HEADER@&!'">{{data.item.invoice}}</div>
            </template>
            <template v-slot:cell(invoicedate)="data">
              {{data.item.invoicedate | moment("DD/MM/YYYY")}}
            </template>
            <template v-slot:cell(action)="data">
              <b-link v-if="data.item.invoice!='#*HEADER@&!'" class="text-primary mr-2" href="#" @click.prevent="openUpdateCostModal(data)">
                <i class="fas fa-pencil-alt"></i>
              </b-link>
              <b-link v-if="data.item.invoice!='#*HEADER@&!'" class="text-danger mr-2" href="#" @click.prevent="deleteCost(data)">
                <i class="fas fa-trash"></i>
              </b-link>
            </template>
            <template slot="bottom-row">
              <td style="text-align:center"><b>TOTAL</b></td>
              <td style="text-align:right"><b>{{sum_total | numeral('0,0')}}</b></td>
              <td/><td/><td/>
            </template>
          </b-table>
      </div>
    </div>

    <!-- COST MODAL -->
    <b-modal
      v-model="costModalShow"
      size="xl"
      @hidden="closeCostModal"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      header-bg-variant="info"
      header-text-variant="light"
      hide-footer
    >
      <template v-slot:modal-title>
        <div v-if="is_creating">ADD SETUP COST</div>
        <div v-else>EDIT SETUP COST</div>
      </template>
      <b-form autocomplete="off" @submit.prevent="submitCost">
        <b-row>
          <b-col cols="6">
            <b-form-group>
              <template v-slot:label>
                Cost (*):
              </template>
              <b-form-select :options="qtake_cost_type_selection" value-field="id" text-field="pickListValue" v-model="qtake_cost.type" :disabled="!is_creating" required/>
            </b-form-group>
          </b-col>
          <b-col cols="6" v-if="qtake_cost.type == costtype_salary">
            <b-form-group>
              <template v-slot:label>
                Salary (*):
              </template>
              <my-currency-input v-model="qtake_cost.per_month_usd"/>
            </b-form-group>
          </b-col>
          <b-col v-else cols="6">
            <b-form-group>
              <template v-slot:label>
                Amount (*):
              </template>
              <my-currency-input v-model="qtake_cost.usd"/>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- @NOTE: HARDCODED IF TYPE = SALARY -->
        <b-row v-if="qtake_cost.type == costtype_salary">
          <b-col>
            <b-form-group>
              <template v-slot:label>
                Employee (*):
              </template>
              <multiselect
                  v-model="qtake_cost.qtake_employee_selected"
                  placeholder
                  :options="employees"
                  track-by="id"
                  label="mahovaten"
                  selectedLabel="Selecting..."
                  select-label="Enter to choose"
                  deselectLabel="Enter to remove"
                  :searchable="true"
                  required>
              </multiselect>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col>
            <b-form-group>
              <template v-slot:label>
                Description (*):
              </template>
              <b-form-input v-model="qtake_cost.name" required/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label v-if="qtake_cost.type == costtype_salary">
                Contract Number:
              </template>
              <template v-slot:label v-else>
                Invoice:
              </template>
              <b-form-input v-model="qtake_cost.invoice"/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label v-if="qtake_cost.type == costtype_salary">
                Contract Date:
              </template>
              <template v-slot:label v-else>
                Invoice Date:
              </template>
              <my-date-picker v-model="qtake_cost.invoicedate_selected"/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="4">
            <b-form-group>
              <template v-slot:label>
                Month (*):
              </template>
              <b-form-select v-model="qtake_cost.start_month" class="mb-2 mr-2" :options="optionsMonthAlt" value-field="value" text-field="text"/>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group>
              <template v-slot:label>
                Year (*):
              </template>
              <b-form-select v-model="qtake_cost.start_year" class="mb-2 mr-2" :options="optionsYearAlt" value-field="value" text-field="text"/>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group>
              <template v-slot:label>
                Payment across how many month(s):
              </template>
              <b-form-input type="number" v-model="qtake_cost.soluong"/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col v-if="qtake_cost.type == costtype_salary">
            <b-form-group>
              <template v-slot:label>
                Total salary:
              </template>
              <b-form-input :value="qtake_cost.usd | numeral('0,0')" readonly></b-form-input>
            </b-form-group>
          </b-col>
          <b-col v-else>
            <b-form-group>
              <template v-slot:label>
                Amount Pays per month:
              </template>
              <b-form-input :value="qtake_cost.per_month_usd | numeral('0,0')" readonly></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <button class="btn btn-info mr-2" style="float:right;" type="submit">
          <i class="fas fa-save mr-2"></i> Save
        </button>
      </b-form>
    </b-modal>
    <!-- END OF COST MODAL -->
  </div>
</template>

<script>
import axios from "axios";
import MyCurrencyInput from "../components/App/MyCurrencyInput";
import MyDatePicker from  "../components/App/MyDatePicker";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

export default {
  name: "QtakeCosts",
  components: {
    MyCurrencyInput,
    MyDatePicker,
    Multiselect,
  },
  data() {
    return {
      year_selected: null,
      month_selected: null,
      qtake_cost_fields: [
        {
          key: "name",
          label: "COST DESCRIPTION",
          thClass: "align-middle",
        },
        {
          key: "per_month_usd",
          label: "USD",
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "invoice",
          label: "INVOICE NO.",
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "invoicedate",
          label: "DATE",
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "action",
          label: "",
          thStyle: { width: "60px !important" },
        },
      ],
      optionsMonth: [ {value: 1, text: "January"},
                      {value: 2, text: "February"},
                      {value: 3, text: "March"},
                      {value: 4, text: "April"},
                      {value: 5, text: "May"},
                      {value: 6, text: "June"},
                      {value: 7, text: "July"},
                      {value: 8, text: "August"},
                      {value: 9, text: "September"},
                      {value: 10, text: "October"},
                      {value: 11, text: "November"},
                      {value: 12, text: "December"},
                      {value: 13, text: "Quarter I"},
                      {value: 14, text: "Quarter II"},
                      {value: 15, text: "Quarter III"},
                      {value: 16, text: "Quarter IV"},
      ],
      optionsMonthAlt: [ {value: 0, text: "January"},
                       {value: 1, text: "February"},
                       {value: 2, text: "March"},
                       {value: 3, text: "April"},
                       {value: 4, text: "May"},
                       {value: 5, text: "June"},
                       {value: 6, text: "July"},
                       {value: 7, text: "August"},
                       {value: 8, text: "September"},
                       {value: 9, text: "October"},
                       {value: 10, text: "November"},
                       {value: 11, text: "December"},
      ],
      qtake_cost_items: [],
      qtake_cost_types: [],
      qtake_cost_type_selection: [],
      employees: [],
      qtake_index: null,
      costModalShow: false,
      is_creating: false,
      qtake_cost: {
        id: 0,
        name: "",
        qtake_employee: 0,
        invoice: "",
        type: null,
        invoicedate: "",
        startdate: "",
        enddate: "",
        usd: 0,
        soluong: 1, // This is for cheat

        // Not-mapped property
        start_month: null,
        start_year: null,
        qtake_employee_selected: null,
        invoicedate_selected: "",
        per_month_usd: 0,
      },
      per_month_usd_buffer: 0,
      qtake_cost_flush: null, // For flushing
      costtype_salary: this.$qtakecosttype_salary,
    }
  },
  watch: {
    'qtake_cost.usd': function (newValue, oldValue) {
      if (this.qtake_cost.soluong == 0) return;
      this.qtake_cost.per_month_usd = newValue / this.qtake_cost.soluong;
    },
    'qtake_cost.soluong': function (newValue, oldValue) {
      if (newValue == 0) return;
      if (this.qtake_cost.type == this.costtype_salary) this.qtake_cost.usd = this.qtake_cost.per_month_usd * newValue;
      else this.qtake_cost.per_month_usd = this.qtake_cost.usd / newValue;
    },
    'qtake_cost.per_month_usd': function (newValue, oldValue) {
      this.qtake_cost.usd = newValue * this.qtake_cost.soluong;
    },
  },
  computed: {
    optionsYear() {
      var result = [];
      var this_year = new Date().getFullYear();
      for (var i = this_year; i >= 2019; i--) {result.push({value: i, text: i});}
      return result;
    },
    optionsYearAlt() {
      var result = [];
      var this_year = new Date().getFullYear();
      for (var i = this_year-2; i < this_year + 5; ++i) {result.push({value: i, text: i});}
      return result;
    },
    sum_total() {
      var sum = 0;
      for (let item of this.qtake_cost_items) {
        if (item.invoice=="#*HEADER@&!") sum += item.per_month_usd;
      }
      return sum;
    }
  },
  beforeRouteEnter(to, from, next) {
    axios
      .all([
        axios.get("/api/qtakecost"),
        axios.get("/api/picklist/qtakecosttype"),
        axios.get("/api/employee/getall"),
      ])
      .then(
        axios.spread((qtake_cost, qtake_cost_type, employee) => {
            next((vm) => vm.initData(qtake_cost.data, qtake_cost_type.data, employee.data));
          }
        )
      );
  },
  beforeRouteUpdate(to, from, next) {
    axios
      .get(`/api/qtakecost`, { params: to.query })
      .then((res) => {
        this.qtake_cost_items = res.data.filter(x => x.intersect > 0);
        for (var cost of this.qtake_cost_items) cost.per_month_usd = cost.per_month_usd * cost.intersect;
        this.insertHeader();
        // next();
      })
      .catch((err) => {
        next();
      });
  },
  methods: {
    initData(qtake_costs, qtake_cost_types, employees) {
      this.qtake_cost_items = qtake_costs.filter(x => x.intersect > 0);
      for (var cost of this.qtake_cost_items) cost.per_month_usd = cost.per_month_usd * cost.intersect;
      this.employees = employees;
      this.year_selected = new Date().getFullYear();
      this.month_selected = -1;
      this.qtake_cost_types = qtake_cost_types;

      this.qtake_cost_flush = Object.assign({}, this.qtake_cost);

      this.insertHeader();

      this.qtake_cost_type_selection = Object.assign([], qtake_cost_types);
      this.qtake_cost_type_selection.unshift({id: null, pickListValue: "--Please choose a Cost type--"})
    },
    queryItem() {
      let query = Object.assign({}, this.$route.query);
      query.q = this.query;
      query.year = this.year_selected;
      query.month = this.month_selected;
      this.$router.push({ query: query });
    },
    openCostModal() {
      this.qtake_cost.start_month = new Date().getMonth();
      this.qtake_cost.start_year = new Date().getFullYear();
      this.is_creating = true;
      this.costModalShow = true;
    },
    closeCostModal() {
      this.qtake_cost = Object.assign({}, this.qtake_cost_flush);
      this.qtake_index = null;
      this.is_creating = false;
      this.costModalShow = false;
    },
    openUpdateCostModal(data) {
      this.qtake_cost.id = data.item.id;
      this.qtake_cost.name = data.item.name;
      this.qtake_cost.qtake_employee = data.item.qtake_employee;
      this.qtake_cost.type = data.item.type;
      this.qtake_cost.invoice = data.item.invoice;
      this.qtake_cost.invoicedate = data.item.invoicedate;
      this.qtake_cost.startdate = data.item.startdate;
      this.qtake_cost.enddate = data.item.enddate;
      this.qtake_cost.usd = data.item.usd;
      this.qtake_cost.per_month_usd = data.item.per_month_usd;
      this.qtake_cost.soluong = data.item.soluong;
      this.qtake_cost.qtake_employee_selected = this.employees.find(x => x.id == data.item.qtake_employee);
      this.qtake_cost.invoicedate_selected = this.$convert_date_string(this.qtake_cost.invoicedate);
      this.qtake_index = data.index;

      let date = new Date(this.qtake_cost.startdate);
      this.qtake_cost.start_month = date.getMonth();
      this.qtake_cost.start_year = date.getFullYear();

      this.per_month_usd_buffer = this.qtake_cost.per_month_usd; // For updating the total when updating
      this.is_creating = false;
      this.costModalShow = true;
    },
    insertHeader() {
      let insert_index = 0;
      for (let type of this.qtake_cost_types) {
        let total = 0;
        let thing_to_insert = {id: -1, name: type.pickListValue, per_month_usd: 0, invoice: "#*HEADER@&!", invoicedate: "", type: type.id};
        var this_header_index = insert_index;
        this.qtake_cost_items.splice(insert_index, 0, thing_to_insert);
        insert_index++;
        if (insert_index == this.qtake_cost_items.length) continue;
        if (this.qtake_cost_items[insert_index].type != type.id) continue;
        for (let i = insert_index; i < this.qtake_cost_items.length; ++i) {
          let item = this.qtake_cost_items[i];
          if (item.type != type.id) break;
          insert_index++;
          total += item.per_month_usd;
        }
        this.qtake_cost_items[this_header_index].per_month_usd = total;
      }
    },
    submitCost() {
      if (this.qtake_cost.soluong == 0) {
        this.$toast.error("Amount of dates have to be atleast 1. Please try again", "Error", {timeout: 2000});
        return;
      }
      this.qtake_cost.startdate = new Date(this.qtake_cost.start_year, this.qtake_cost.start_month, 1);
      this.qtake_cost.enddate = this.qtake_cost.startdate;
      this.qtake_cost.soluong = parseInt(this.qtake_cost.soluong); // Why we have to do this ????

      this.qtake_cost.invoicedate = this.qtake_cost.invoicedate_selected == null ? "" : this.$convert_string_date(this.qtake_cost.invoicedate_selected);
      if (this.qtake_cost.qtake_employee_selected != null) this.qtake_cost.qtake_employee = this.qtake_cost.qtake_employee_selected.id;

      if (this.is_creating) this.addCost();
      else this.updateCost();
    },
    addCost() {
      axios.post(`/api/qtakecost/${this.year_selected}/${this.month_selected}`, this.qtake_cost)
      .then((res) => {
        let qtake = Object.assign({}, res.data.item);
        let intersect = res.data.intersect;

        qtake.per_month_usd = (qtake.usd / qtake.soluong) * intersect;

        // If this thing is in the current filter date then we add it in, if not then don't bother
        if (intersect > 0) {
          // First we find on what category this thing belongs in
             var category_index = this.qtake_cost_types.findIndex(x => x.id == qtake.type);
          // If this thing belongs to the last category. We just push it in at the bottom of the array.
          if (category_index == this.qtake_cost_types.length - 1) {
            this.qtake_cost_items.push(qtake);
          }
          else {
            // If not we just find the next category header index and add it in there
            let next_category_type = this.qtake_cost_types[category_index + 1].id;
            var insert_index = this.qtake_cost_items.findIndex(x => x.type == next_category_type);
            this.qtake_cost_items.splice(insert_index, 0, qtake);
          }

          // If we add it to the array we need to update the total as well
          let category_header_index = this.qtake_cost_items.findIndex(x => x.type == qtake.type);
          this.qtake_cost_items[category_header_index].per_month_usd += qtake.per_month_usd;
        }

        this.closeCostModal();
        this.$toast.success("Successfully added!", "Success", {timeout: 2000});
      })
      .catch((err) => {this.$toast.error(err.response.data, "Error", {timeout: 2000});})
    },
    updateCost() {
      let category_header_index = this.qtake_cost_items.findIndex(x => x.type == this.qtake_cost.type);
      this.qtake_cost_items[category_header_index].per_month_usd -= this.per_month_usd_buffer;

      axios.put(`/api/qtakecost/${this.year_selected}/${this.month_selected}`, this.qtake_cost)
      .then((res) => {
        let qtake = Object.assign({}, res.data.item);
        let intersect = res.data.intersect;

        let update_index = this.qtake_index;

        if (intersect > 0) {
          qtake.per_month_usd = (qtake.usd / qtake.soluong) * intersect;
          this.qtake_cost_items = this.$insert_array_parse_json(qtake, this.qtake_cost_items, update_index);
          this.qtake_cost_items[category_header_index].per_month_usd += qtake.per_month_usd;
        }
        else {
          this.qtake_cost_items.splice(update_index, 1);
        }

        this.closeCostModal();
        this.$toast.success("Successfully updated!", "Success", {timeout: 2000});
      })
      .catch((err) => {this.$toast.error(err.response.data, "Error", {timeout: 2000});})
    },
    deleteCost(data) {
      this.$toast.question("Do you really want to delete this?", "Warning", {
            timeout: 20000,
            close: false,
            overlay: true,
            displayMode: "once",
            position: "center",
            buttons: [
                [
                    "<button><b>Có</b></button>",
                    (instance, toast) => {
                        axios
                        .delete(`/api/qtakecost/${data.item.id}`)
                        .then((res) => {
                            this.qtake_cost_items.splice(data.index, 1);
                            this.$toast.success("Successfully delete!", "Success", {timeout: 2000});
                        })
                        .catch((err) => {
                          this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
                        });
                        instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                    },
                    true,
                ],
                [
                    "<button>Không</button>",
                    function (instance, toast) {
                        instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                    },
                ],
            ],
        });
    },
    exportExcel() {
     let query = Object.assign({}, this.$route.query);
     query.year = this.year_selected;
     query.month = this.month_selected;

      axios({
        method: "get",
        url: `/api/qtakereport/cost`,
       params: query,
        responseType: "blob", // important
        })
        .then((res) => {
          this.$download_excel_file(res);
        })
        .catch((err) => {this.$toast.error(err.response.data, "Error", {timeout: 2000});});
    }
  }
}
</script>